// extracted by mini-css-extract-plugin
module.exports = {"add_group":"Units_add_group_3smfT","bulk_edit":"Units_bulk_edit_105kc"};